<script>
import Animations from '../animations';
import { _deepCopy } from '../util/helper.js';

export default {
	name: 'AnimationView',
	props: ['animation', 'rect'],
	components: Animations,
	mounted() {

		this.$root.$on('startAllAnimations', _ => {
			this.$root.$emit('stop');
			this.$root.$emit('start');
		});

		this.$root.$on('startAnimation', _ => {
			this.$root.$emit('stop');
			this.$root.$emit('showAnimatedModules');
			this.$root.$emit('init' + this.$store.state.activeAnimation, this.$store.state.activeAnimation);
			this.$root.$emit('start' + this.$store.state.activeAnimation, this.$store.state.activeAnimation);
		});

		this.$root.$on('changeAnimation', change => {
				let self = change.self;
				const type = change.type;
				this.$root.$emit('stop');
				self.module.animation[self.$store.state.activeAnimationIndex][type] = change.value;
				const animation = self.module.animation;
				self.commitChange('animation', { animation } );
				this.$root.$emit('init' + self.$store.state.activeAnimation, this.$store.state.activeAnimation);

				if(this.$store.oldAnimationChange != change) {
					this.$store.oldAnimationChange = change
					this.$store.commit('setHistory', 'animation-change');
					if(this.$store.oldAnimationType != type) {
						this.$store.oldAnimationType = type;
					}
				}
				this.$root.$emit('showAnimatedModules');
		});
	},
	render(createElement) {
		const root = createElement('div', {
			class: 'fd-animation'
		});

		let current = root;
		(this.animation || [])
			.filter(a => Animations[a.name])
			.forEach(animation => {
				const animationEl = createElement(animation.name, {
					class: 'fd-animation',
					attrs: { animation, rect: this.rect }
				});

				if(current.componentOptions) {
					current.componentOptions.children = [animationEl];
				}
				else {
					current.children = [animationEl];
				}
				current = animationEl;
			});

		if(current.componentOptions) {
			current.componentOptions.children = this.$slots.default;
		}
		else {
			current.children = this.$slots.default;
		}

		return root;
	}
}
</script>

<style>
.fd-animation {
	display: block;
	width: 100%;
	height: 100%;
}

/*!
* animate.css -http://daneden.me/animate
* Version - 3.6.0
* Licensed under the MIT license - http://opensource.org/licenses/MIT
*
* Copyright (c) 2018 Daniel Eden
*/
.fd-animation.animated {
	animation-duration: 1s;
	animation-fill-mode: both;
}

.fd-animation.animated.infinite {
	animation-iteration-count: infinite;
}

/*!
 * WickedCSS v1.0 (https://github.com/kristofferandreasen/wickedCSS)
 * Copyright 2015 Kristoffer Andreasen
 * MIT License
 */
</style>
